import { NgModule } from '@angular/core';

import { AwaitSpinnerDirective } from './await-spinner/await-spinner.directive';
import { SpinnerUiComponent } from './spinner-ui/spinner-ui.component';

@NgModule({
  imports: [AwaitSpinnerDirective, SpinnerUiComponent],
  exports: [AwaitSpinnerDirective, SpinnerUiComponent],
})
export class SharedUiAwaitSpinnerModule {}
